var supportsCSSPropertyValue = function () {
    return !!document.documentElement.style.getPropertyValue('--vh');
};

export { supportsCSSPropertyValue as s };
//# sourceMappingURL=supportsCSSPropertyValue-b6b8cdb3.js.map
